class BobaInfiniteCarousel {
  constructor(element) {
    this.marqueeElement = element;
    this.speed = 40; // px/s - adjust as needed
    this.maxSpeed = 280;
    this.targetSpeed = this.speed; // positive = left, negative = right
    this.currentSpeed = this.speed;
    this.position = 0;
    this.trackWidth = 0;
    this.animationFrame = null;
    this.paused = false;
    this.currentDirection = "left";
    this.init();
  }

  init() {
    const marqueeContent =
      this.marqueeElement.querySelector(".infinite-carousel");
    if (!marqueeContent) return;

    let items = Array.from(marqueeContent.children);
    if (!items.length) return;

    const containerWidth = this.marqueeElement.offsetWidth;
    const contentWidth = marqueeContent.offsetWidth;
    const duplicatesNeeded = Math.ceil(containerWidth / contentWidth) - 1;

    for (let i = 0; i < duplicatesNeeded; i++) {
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        marqueeContent.appendChild(clone);
      });
    }

    const clone = marqueeContent.cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    this.marqueeElement.appendChild(clone);

    // Store the width of one track for looping
    this.trackWidth = marqueeContent.offsetWidth;
    const gap = parseFloat(getComputedStyle(this.marqueeElement).gap) || 0;
    this.loopWidth = this.trackWidth + gap;

    this.tracks = this.marqueeElement.querySelectorAll(".infinite-carousel");

    // Pause on hover
    this.marqueeElement.addEventListener("mouseenter", () => {
      this.paused = true;
    });
    this.marqueeElement.addEventListener("mouseleave", () => {
      this.paused = false;
    });

    this.marqueeElement.classList.add("initialised");
    this.tick();
    this.initControls();
  }

  tick() {
    this.animationFrame = requestAnimationFrame((timestamp) => {
      if (!this.lastTimestamp) this.lastTimestamp = timestamp;
      const delta = (timestamp - this.lastTimestamp) / 1000; // seconds
      this.lastTimestamp = timestamp;

      if (!this.paused) {
        // Ease current speed toward target speed (passes through 0 for smooth direction change)
        this.currentSpeed += (this.targetSpeed - this.currentSpeed) * 0.05;

        this.position -= this.currentSpeed * delta;

        // Loop
        if (this.position <= -this.loopWidth) this.position += this.loopWidth;
        if (this.position >= 0) this.position -= this.loopWidth;

        this.tracks.forEach((track) => {
          track.style.transform = `translateX(${this.position}px)`;
        });
      }

      this.tick();
    });
  }

  initControls() {
    const closestContainer = this.marqueeElement.closest(".container");
    const leftBtn = closestContainer?.querySelector(".direction-left");
    const rightBtn = closestContainer?.querySelector(".direction-right");

    if (!leftBtn || !rightBtn) return;

    leftBtn.addEventListener("click", () => this.changeDirection("left"));
    rightBtn.addEventListener("click", () => this.changeDirection("right"));
  }

  changeDirection(direction) {
    const sign = direction === "right" ? -1 : 1;

    if (direction === this.currentDirection) {
      // Speed up
      const newSpeed = Math.min(
        Math.abs(this.targetSpeed) * 1.25,
        this.maxSpeed,
      );
      this.targetSpeed = sign * newSpeed;

      if (Math.abs(this.targetSpeed) >= this.maxSpeed) {
        const btn = this.marqueeElement
          .closest(".container")
          ?.querySelector(`.direction-${direction}`);
        btn?.setAttribute("disabled", "disabled");
      }

      console.log("Speed:", this.targetSpeed);
    } else {
      // Change direction — just flip the target, easing does the rest

      // Reset targetSpeed to initial speed in the new direction to ensure a smooth transition
      this.targetSpeed = sign * this.speed;
      // this.targetSpeed = sign * Math.abs(this.targetSpeed);
      this.currentDirection = direction;

      console.log("switching direction:", this.targetSpeed);

      const container = this.marqueeElement.closest(".container");
      container?.querySelector(".direction-left")?.removeAttribute("disabled");
      container?.querySelector(".direction-right")?.removeAttribute("disabled");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".infinite-carousel-wrapper").forEach((marquee) => {
    new BobaInfiniteCarousel(marquee);
  });
});
